module.exports = __webpack_public_path__ + "img/65_7.a38ea2ba.png";